import Styles from "./styles.module.css"

export default function JourneyCard({program, onClick}){
    return(<div className={Styles.JourneyCard} onClick={()=> onClick(program)}>
        
            <img src={program.thumb_image} 
                 alt={program.title} 
                 className={Styles.JourneyImage}
            />
        
        <h2>{program.title}</h2>
        <div className={Styles.MetaRow}>
            <span className={Styles.description}>{program.promo_text}</span>
            <span> • </span>
            <span className={Styles.meta}>{program.description}</span>
        </div>
    </div>)
}